// extracted by mini-css-extract-plugin
export default {"list":"ServiceFieldsList_list__cQb+r"};